'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unregisterPerson = exports.getAccountsWithPartialBalancesForFeis = exports.getUnpaidAccountsForFeis = exports.unregisterForEvent = exports.registerForEvent = exports.returnProduct = exports.purchaseProduct = exports.refreshBalance = exports.updateCart = undefined;

var _middleware = require('../../middleware');

var _accounts = require('../accounts');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var updateCart = exports.updateCart = function updateCart(feis_id, acct_id) {
  var ignore_cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var show_loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    dispatch((0, _accounts.getAccount)(acct_id));
    dispatch((0, _accounts.getDependents)(acct_id));

    // prefer the cached version
    if (!ignore_cache && getState().getIn((0, _paths.cartPath)(feis_id, acct_id))) {
      return;
    }

    return dispatch(_defineProperty({
      feis_id: feis_id,
      acct_id: acct_id,
      show_loading: show_loading

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/cart'
      },
      types: ['UPDATE_CART_START', 'UPDATE_CART', 'UPDATE_CART_ERROR']
    }));
  };
};

var refreshBalance = exports.refreshBalance = function refreshBalance(feis_id, acct_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/balance'
      },
      types: ['UPDATE_BALANCE_START', 'UPDATE_BALANCE', 'UPDATE_BALANCE_ERROR']
    }));
  };
};

var purchaseProduct = exports.purchaseProduct = function purchaseProduct(feis_id, acct_id, product_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        method: 'POST',
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/purchases',
        data: {
          product_id: product_id
        }
      },
      types: ['PURCHASE_PRODUCT_START', 'PURCHASE_PRODUCT', 'PURCHASE_PRODUCT_ERROR']
    }))

    /**
     * If we don't already have a copy of the cart for this person, we need to fetch it; otherwise, it
     * is sufficient to simply update the balance.
     */
    .then(function (resp) {
      return dispatch(updateCart(feis_id, acct_id, true));
    });
  };
};

var returnProduct = exports.returnProduct = function returnProduct(feis_id, acct_id, purchase_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id,
      purchase_id: purchase_id

    }, _middleware.CALL_API, {
      config: {
        method: 'DELETE',
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/purchases/' + purchase_id
      },
      types: ['RETURN_PRODUCT_START', 'RETURN_PRODUCT', 'RETURN_PRODUCT_ERROR']
    }))

    /**
     * If we don't already have a copy of the cart for this person, we need to fetch it; otherwise, it
     * is sufficient to simply update the balance.
     */
    .then(function () {
      return dispatch(updateCart(feis_id, acct_id, true));
    });
  };
};

var registerForEvent = exports.registerForEvent = function registerForEvent(feis_id, event_id, acct_id, person_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id,
      person_id: person_id,
      event_id: event_id

    }, _middleware.CALL_API, {
      config: {
        method: 'POST',
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/registrations/' + person_id,
        data: {
          event_id: event_id
        }
      },
      types: ['REGISTER_FOR_EVENT_START', 'REGISTER_FOR_EVENT', 'REGISTER_FOR_EVENT_ERROR']
    }))

    /**
     * If we don't already have a copy of the cart for this person, we need to fetch it; otherwise, it
     * is sufficient to simply update the balance.
     */
    .then(function () {
      return dispatch(updateCart(feis_id, acct_id, true));
    });
  };
};

var unregisterForEvent = exports.unregisterForEvent = function unregisterForEvent(feis_id, event_id, acct_id, person_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id,
      person_id: person_id,
      event_id: event_id

    }, _middleware.CALL_API, {
      config: {
        method: 'DELETE',
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/registrations/' + person_id + '/' + event_id
      },
      types: ['UNREGISTER_FOR_EVENT_START', 'UNREGISTER_FOR_EVENT', 'UNREGISTER_FOR_EVENT_ERROR']
    }))

    /**
     * If we don't already have a copy of the cart for this person, we need to fetch it; otherwise, it
     * is sufficient to simply update the balance.
     */
    .then(function () {
      return dispatch(updateCart(feis_id, acct_id, true));
    });
  };
};

var getUnpaidAccountsForFeis = exports.getUnpaidAccountsForFeis = function getUnpaidAccountsForFeis(feis_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts-without-payments'
      },
      types: ['GET_UNPAID_ACCOUNTS_FOR_FEIS_START', 'GET_UNPAID_ACCOUNTS_FOR_FEIS', 'GET_UNPAID_ACCOUNTS_FOR_FEIS_ERROR']
    }))

    /**
     * For each unpaid account we need to load its current balance due.
     */
    .then(function (res) {
      res.payload.forEach(function (account) {
        return dispatch(refreshBalance(feis_id, account.id));
      });
    });
  };
};

var getAccountsWithPartialBalancesForFeis = exports.getAccountsWithPartialBalancesForFeis = function getAccountsWithPartialBalancesForFeis(feis_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts-with-partial-balance'
      },
      types: ['GET_ACCOUNTS_WITH_PARTIAL_BALANCE_FOR_FEIS_START', 'GET_ACCOUNTS_WITH_PARTIAL_BALANCE_FOR_FEIS', 'GET_ACCOUNTS_WITH_PARTIAL_BALANCE_FOR_FEIS_ERROR']
    }));
  };
};

var unregisterPerson = exports.unregisterPerson = function unregisterPerson(feis_id, pid, acct_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      pid: pid,
      acct_id: acct_id

    }, _middleware.CALL_API, {
      config: {
        method: 'DELETE',
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/registrations/' + pid
        //data: {
        //  persons,
        //},
      },
      types: ['UNREGISTER_FOR_ALL_EVENTS_START', 'UNREGISTER_FOR_ALL_EVENTS', 'UNREGISTER_FOR_ALL_EVENTS_ERROR']
    }))
    /**
     * If we don't already have a copy of the cart for this person, we need to fetch it; otherwise, it
     * is sufficient to simply update the balance.
     */
    .then(function () {
      return dispatch(updateCart(feis_id, acct_id, true));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/cart/index.js
// module id = 65
// module chunks = 0